import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

const OCCASIONS = ['All', 'Casual', 'Business', 'Athletic', 'Streetwear', 'Formal'];

export default function Module03({ data }) {
  const { posts = [] } = data;
  const [filter, setFilter] = useState('All');

  const filtered =
    filter === 'All'
      ? posts
      : posts.filter((p) => p.occasion?.toLowerCase() === filter.toLowerCase());

  return (
    <div className="space-y-5">

      {/* Filter row */}
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-none">
        {OCCASIONS.map((o) => (
          <button
            key={o}
            onClick={() => setFilter(o)}
            className="flex-shrink-0 px-3 py-1.5 text-[9px] tracking-[0.2em] uppercase font-medium transition-all border"
            style={filter === o
              ? { borderColor: 'var(--gold)', color: 'var(--gold)' }
              : { borderColor: 'rgba(255,255,255,0.1)', color: '#666' }}
          >
            {o}
          </button>
        ))}
      </div>

      {/* Post grid */}
      <div className="grid grid-cols-2 gap-3">
        {filtered.map((post, i) => <PostCard key={i} post={post} />)}
      </div>

      {filtered.length === 0 && (
        <p className="text-center text-[10px] tracking-[0.2em] uppercase text-gray-600 py-10">
          No posts for this filter.
        </p>
      )}
    </div>
  );
}

function PostCard({ post }) {
  return (
    <div className="border border-white/8 overflow-hidden">
      {post.image_url ? (
        <img src={post.image_url} alt={post.vibe} className="w-full aspect-square object-cover" loading="lazy" />
      ) : (
        <div className="w-full aspect-square bg-white/3 flex items-end p-2">
          <div className="flex gap-1 flex-wrap">
            {post.dominant_colors?.map((c, i) => (
              <span key={i} className="text-[9px] bg-black/40 px-1.5 py-0.5 text-gray-500">{c}</span>
            ))}
          </div>
        </div>
      )}
      <div className="p-2.5">
        <div className="flex items-center justify-between mb-1">
          <span className="text-[9px] tracking-[0.15em] uppercase" style={{ color: 'var(--gold)' }}>
            {post.occasion}
          </span>
          <div className="flex items-center gap-1.5">
            <span className="text-[9px] text-gray-600">★ {post.style_score}/10</span>
            {post.post_url && (
              <a href={post.post_url} target="_blank" rel="noopener noreferrer"
                onClick={e => e.stopPropagation()} className="text-gray-700 hover:text-white transition-colors">
                <ExternalLink size={10} />
              </a>
            )}
          </div>
        </div>
        <p className="text-[11px] text-gray-400 leading-snug">{post.vibe}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {post.tag && (
            <span className="text-[9px] border px-1.5 py-0.5" style={{ borderColor: 'var(--gold-dim)', color: 'var(--gold)' }}>
              #{post.tag}
            </span>
          )}
          {post.key_items?.slice(0, 2).map((item, i) => (
            <span key={i} className="text-[9px] border border-white/10 px-1.5 py-0.5 text-gray-600">{item}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
